let BulletList = {};

BulletList.init =  () => {
	BulletList.collapse(4);
}

BulletList.collapse = (maxItem) => {
	let bulletList = $('.js-bullet-list');

	if (bulletList.length === 0) {
		return;
	}

	$.each(bulletList, function () {
		let $bulletList = $(this);

		let bulletListToggle = $bulletList.find('.js-bullet-list-toggle');
		let bulletListItem = $bulletList.find('.js-bullet-list-collapse li');
		let itemCount = $bulletList.find('.js-bullet-list-collapse li').length;

		if (itemCount > maxItem) {
			$bulletList.addClass('is-hidden');
			bulletListItem.slice(maxItem, itemCount).addClass('is-hidden');
		
			bulletListToggle.click(() => {
				if ($bulletList.hasClass('is-hidden')) {
					$bulletList.removeClass('is-hidden');
				} else {
					$bulletList.addClass('is-hidden');
				}
			});
		}  
	});
}


BulletList.init();


// WEBPACK FOOTER //
// ./scripts/components/bullet-list.js